<template>
  <li
    class="onhover-dropdown"
    style="list-style-type: none"
  >
    <h6 style="color: wheat">
      {{ $i18n.locale.toUpperCase() }}
    </h6>
    <ul class="language-dropdown onhover-show-div p-20">
      <li>
        <a
          href="#"
          @click="changeLanguage('en', $event)"
        >
          <i class="flag-icon flag-icon-gb-eng" /> English
        </a>
      </li>
      <li>
        <a
          href="#"
          @click="changeLanguage('az', $event)"
        >
          <i class="flag-icon flag-icon-az" /> Azərbaycan
        </a>
      </li>
      <li>
        <a
          href="#"
          @click="changeLanguage('ru', $event)"
        >
          <i class="flag-icon flag-icon-ru" /> Pусский
        </a>
      </li>
    </ul>
  </li>
</template>


<script>
export default {
  name: 'LocaleChanger',
  data() {
    return {
      langs: ['en', 'ru', 'az'] // Add more languages as needed
    };
  },
  methods: {
    changeLanguage(lang, event) {
      event.preventDefault();
      localStorage.setItem('userLang', lang); // Store selected language in localStorage
      this.$i18n.locale = lang;
      window.location.reload();
    }
  }
}
</script>

<style scoped>

</style>
